<template>
  <div class="main-con el-main">
    <router-view />
  </div>
</template>

<script>
    export default {
        name: "PaymentView"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/Payment.vue